export const FAQ_LOAN_TYPES = {
  REGULAR: 'regular',
  CRYPTO: 'crypto',
};

export const FAQ_REGULAR_CONTACT = {
  email: 'customerservice@servicingusa.com',
  phone: '(888) 502-8082',
  phoneHref: 'tel:+18885028082',
  hours: 'Available Monday - Friday, 8am - 8pm PT',
};

export const FAQ_CRYPTO_CONTACT = {
  email: 'customerservice@servicingusa.com',
  phone: '(888) 502-8082',
  phoneHref: 'tel:+18885028082',
  hours: 'Available Monday - Friday, 8am - 5pm PT',
};

export const getFaqContact = (loanType) => (
  loanType === FAQ_LOAN_TYPES.CRYPTO ? FAQ_CRYPTO_CONTACT : FAQ_REGULAR_CONTACT
);

export const REGULAR_FAQ_CATEGORIES = [
  {
    id: 'general-information',
    title: 'General Information',
    questions: [
      {
        question: 'Will all these FAQs apply to my loan?',
        answer: 'This FAQ provides general guidance and applies to most loans. However, your specific loan agreement may contain terms that differ from the information provided here. If there is a conflict, the terms of your loan agreement will apply. Please refer to your loan agreement for details about your loan.',
      },
      {
        question: 'How do I make payments?',
        answer: 'You can make payments at any time through your customer portal or by calling us at (888) 502-8082.',
      },
      {
        question: 'Can I make partial payments?',
        answer: 'Yes. Partial payments reduce your outstanding balance but may not satisfy required payments or other required actions unless the full required amount is met.',
      },
      {
        question: 'Can I pay off my loan early?',
        answer: 'Yes. You may pay off your loan early at any time with no prepayment penalties.',
      },
      {
        question: 'What happens at loan maturity?',
        answer: 'At maturity, any remaining loan balance plus accrued interest must be paid in full. If the balance is not paid, actions may be taken in accordance with your loan agreement.',
      },
      {
        question: 'What happens if I miss a payment?',
        answer: 'If you miss a required payment, your account may become past due. Continued delinquency may result in additional actions as outlined in your loan agreement.',
      },
      {
        question: 'Are late fees charged?',
        answer: 'Late fees, if applicable, are outlined in your loan agreement and will be reflected in your account if assessed.',
      },
      {
        question: 'How do I contact customer support?',
        answer: 'You can contact customer support at customerservice@servicingusa.com or by calling (888) 502-8082.',
      },
      {
        question: 'How do I set up or cancel autopay?',
        answer: 'You can set up autopay to match your payment schedule through your customer portal if not already enrolled. To cancel autopay, please call customer service at (888) 502-8082. Please note that some promotional loans require autopay to remain active to maintain promotional terms.',
      },
      {
        question: 'How do I update my payment method or bank account?',
        answer: 'Go to the My Loan tab in your customer portal and navigate to the Payment Methods section. You can add or remove payment methods there. Payment methods currently being used for autopay cannot be removed. If you need to adjust your autopay payment method, please call customer service at (888) 502-8082.',
      },
      {
        question: 'How do I get a payoff quote?',
        answer: 'You can get a payoff quote from the Make a Payment section in your customer portal or by calling customer service at (888) 502-8082. Payoff quotes are valid for a specific period of time and include your principal balance, accrued interest, and any applicable fees as of the payoff date.',
      },
      {
        question: 'How do I dispute a charge or payment on my account?',
        answer: 'If you believe there is an error on your account, contact customer service immediately at (888) 502-8082 or email customerservice@servicingusa.com. Please provide details about the charge or payment in question so we can investigate and resolve the issue.',
      },
    ],
  },
  {
    id: 'zip-promo',
    title: 'ZIP Promo — No Interest on Principal Option',
    questions: [
      {
        question: 'What is the No Interest on Principal Option Promotion?',
        answer: 'If your loan includes this promotion, you can pay the principal amount of your loan without paying any interest on the unpaid principal balance if you pay the full principal amount before the promotional period expires. The promotional period ends on the scheduled due date of your scheduled monthly payment corresponding with the end of the promotional period. We will keep any prepaid finance charge, including the non-refundable loan origination fee if applicable.',
      },
      {
        question: 'What disqualifies me from the No Interest on Principal Option Promotion (ZIP promo)?',
        answer: 'You will lose the promotion if: You make any scheduled monthly payment during the promotional period later than 16 days after its scheduled due date; You miss a scheduled payment during the promotional period; You do not pay the full principal amount before the promotional period expires; You cancel or remove autopay from your loan during the promotional period.',
      },
      {
        question: 'What happens if the promotion expires before I pay off my loan?',
        answer: 'If the promotion expires, any extra payments you made will be treated as partial prepayments. You will pay interest on the principal amount from the disbursement date at the interest rate set forth in your loan agreement. If you pay the full principal within the promotional period, you will receive a credit for any interest paid during that period. If the full principal is not paid within the promotional period, no interest credit will be applied, and you will remain responsible for all interest accrued and paid throughout the loan term.',
      },
    ],
  },
  {
    id: 'origination-fee',
    title: 'Origination Fee & Prepayment',
    questions: [
      {
        question: 'What is the loan origination fee?',
        answer: 'The loan origination fee, if applicable to your loan, is a non-refundable fee that is withheld from your loan proceeds and is fully earned as of the date of the loan. This fee will not be refunded upon early payment, whether voluntary or as a result of default, except as otherwise required by law.',
      },
      {
        question: 'Will paying off my loan early reduce the number of payments I have to make?',
        answer: 'Yes. Early payments reduce the principal balance due and may result in you making fewer payments. Early payments do not relieve you of your obligation to continue making payments under your payment schedule, except if you qualify for the No Interest on Principal Option Promotion.',
      },
    ],
  },
  {
    id: 'payment-application',
    title: 'Payment Application & Interest',
    questions: [
      {
        question: 'How are my payments applied?',
        answer: 'Per your loan agreement, payments are applied first to any accrued unpaid interest, then to principal, and then to any late fees or other charges.',
      },
      {
        question: 'How is interest calculated on my loan?',
        answer: 'Interest accrues on the unpaid principal balance on a daily basis. Please refer to your loan agreement for details about your loan and how interest may be calculated.',
      },
    ],
  },
  {
    id: 'refunds',
    title: 'Refunds and Unused Funds',
    questions: [
      {
        question: 'How are refunds or unused funds handled for my loan?',
        answer: 'The refund process depends on your loan type. For Point of Sale (Merchant) Loans: Merchant-approved refunds are applied to your loan balance. If we receive a partial refund within 60 days of your loan date, the refunded amount plus a percentage-based adjustment and origination fee will be applied to your balance. If the refund exceeds the threshold outlined in your loan agreement, your loan may be reamortized. A full refund within 60 days cancels the loan with no further payment obligation. Refunds received after 60 days are applied to your balance without reamortization. For FreshStart Debt Settlement Loans: Excess proceeds (funds remaining after all enrolled debts are satisfied) will be returned to LendingUSA by your debt settlement company after all debts have been settled. All excess proceeds will be applied to the outstanding amount owed under your loan agreement. If the excess proceeds exceed the threshold outlined in your loan agreement and are applied within the timeframe specified in your loan agreement, your loan will be reamortized and you will receive a credit to your outstanding balance equal to a percentage of the excess proceeds and the loan origination fee.',
      },
    ],
  },
  {
    id: 'freshstart',
    title: 'FreshStart/LendingUSA Debt Settlement Loans',
    questions: [
      {
        question: 'How does my FreshStart loan work with my debt settlement company?',
        answer: 'Your FreshStart loan was designed to fund the settlement of debts you enrolled in your debt settlement program. Here\'s how it works: You worked with your debt settlement company and made payments for a period of time. You applied for and were approved for a FreshStart loan. The loan funds were deposited into your account with your debt settlement company. Your debt settlement company used those funds to negotiate and pay off your enrolled debts and their fees. Your prior debts have now been replaced with your FreshStart loan payment, which is serviced by LendingUSA.',
      },
      {
        question: 'Does LendingUSA manage my debt settlement process?',
        answer: 'No. LendingUSA does not manage or control the debt settlement process. Your debt settlement company handles all negotiations and settlement activities. If you have questions or concerns about the settlement process, you must contact your debt settlement company directly.',
      },
      {
        question: 'Can I cancel my FreshStart loan?',
        answer: 'In most cases, no. The loan funds have already been used by your debt settlement company to settle the debts enrolled in your program. Because the funds have already been distributed, the loan cannot be reversed or canceled. If there is any remaining balance after settlements are completed, any unused funds will be returned to LendingUSA and applied as a credit to your loan balance. If your debt settlement company is unable to settle a debt, those unused funds will also be returned and applied as a credit to your loan balance.',
      },
    ],
  },
  {
    id: 'collections',
    title: 'Collections & Past Due Accounts',
    questions: [
      {
        question: 'What if I\'m experiencing a financial hardship or am behind on payments?',
        answer: 'We\'re here to help. Contact customer service as soon as possible at (888) 502-8082 to discuss your situation. Payment arrangements and other options may be available and are evaluated on a case-by-case basis. The sooner you reach out, the more options may be available to help you get back on track.',
      },
      {
        question: 'Can I lower my payments?',
        answer: 'If you\'re going through a difficult time financially, you may qualify for reduced monthly payments. We\'re here to work with you. Contact customer service at (888) 502-8082 to discuss your situation and explore available options that fit your circumstances.',
      },
      {
        question: 'Can I defer a payment?',
        answer: 'Payment deferral options may be available in certain circumstances. Contact customer service to discuss your situation. Deferred payments may extend your loan term, and interest will continue to accrue during the deferral period.',
      },
      {
        question: 'How do I request a settlement?',
        answer: 'Contact customer service at (888) 502-8082 to discuss settlement options. Not all accounts qualify for settlement, and approval is at LendingUSA\'s discretion based on your account status and payment history.',
      },
    ],
  },
];

export const CRYPTO_FAQ_CATEGORIES = [
  {
    id: 'collateral-return',
    title: 'Collateral Return & Payoff',
    questions: [
      {
        question: 'What happens to my collateral when my loan is paid off?',
        answer: 'Once your loan is paid in full, your crypto collateral will be released and returned to you after your wallet ID is verified. You will receive instructions on how to claim your collateral after your final payment is processed.',
      },
      {
        question: 'How long does collateral return take after payoff?',
        answer: 'Collateral return typically takes 7 business days after your final payment is processed and your loan is confirmed as paid in full. We will contact you for wallet verification prior to returning your collateral.',
      },
      {
        question: 'What type of cryptocurrency can I add as collateral?',
        answer: 'You can only add the same type of cryptocurrency that was originally used as collateral for your loan.',
      },
      {
        question: 'What LTV thresholds will trigger a margin call or liquidation?',
        answer: 'LTV thresholds that trigger margin calls or liquidation are specific to your loan and are outlined in your loan agreement. Your customer portal displays your current LTV and any applicable thresholds. Contact customer service at (888) 502-8082 if you have questions about your specific thresholds.',
      },
    ],
  },
  {
    id: 'repayment-types',
    title: 'Repayment Types',
    questions: [
      {
        question: 'Why is my loan balance increasing?',
        answer: 'If your loan is Interest-Only or No Monthly Payment, interest continues to accrue and may cause your total loan balance to increase until payments are made.',
      },
    ],
  },
  {
    id: 'loan-basics',
    title: 'Loan Basics',
    questions: [
      {
        question: 'How does my crypto-backed loan work after funding?',
        answer: 'Once your loan is funded, your crypto collateral remains securely held with our custody partner while you repay your loan based on your selected repayment type. Your customer portal displays your loan balance, payment information, and collateral details.',
      },
      {
        question: 'What is Loan-to-Value (LTV)?',
        answer: 'Loan-to-Value (LTV) is the percentage that compares your outstanding loan balance to the current market value of your crypto collateral. Your current LTV is shown in your customer portal and may change due to market fluctuations or changes in your loan balance.',
      },
      {
        question: 'What is current market value?',
        answer: 'Current market value is the estimated real-time value of your crypto collateral based on market pricing. Crypto markets are volatile and prices can change at any time.',
      },
    ],
  },
  {
    id: 'market-volatility',
    title: 'Market Volatility',
    questions: [
      {
        question: 'Why does my LTV change even if I did not make a payment?',
        answer: 'Your LTV can change due to fluctuations in crypto market prices or because interest accrues to your loan balance. Even small price changes may impact your LTV.',
      },
      {
        question: 'What happens if crypto prices fall?',
        answer: 'If the value of your crypto collateral decreases, your LTV increases. If your LTV exceeds required thresholds, you may need to make a payment or add collateral to reduce risk. If required actions are not taken, liquidation may occur.',
      },
      {
        question: 'What happens if crypto prices rise?',
        answer: 'If the value of your crypto collateral rises, your LTV decreases, improving the overall health of your loan and reducing liquidation risk.',
      },
    ],
  },
  {
    id: 'collateral-management',
    title: 'Collateral Management',
    questions: [
      {
        question: 'Can I add more crypto collateral?',
        answer: 'You can add additional crypto collateral to reduce your LTV at any time. Click Add Collateral in your portal to see available options.',
      },
      {
        question: 'Can I withdraw some of my crypto collateral?',
        answer: 'Once crypto collateral has been deposited, it can no longer be accessed until the loan is paid off.',
      },
      {
        question: 'Will I be notified if action is required?',
        answer: 'We attempt to notify you when your LTV approaches risk thresholds or when your account becomes past due. Due to market volatility, liquidation may occur with limited or no advance notice.',
      },
    ],
  },
  {
    id: 'liquidation',
    title: 'Liquidation',
    questions: [
      {
        question: 'Can my crypto be liquidated?',
        answer: 'Yes. If your LTV exceeds required limits, your loan becomes seriously past due, or other loan terms are not met, some or all of your crypto collateral may be sold to repay your loan.',
      },
      {
        question: 'How much crypto will be liquidated?',
        answer: 'The amount liquidated depends on your outstanding loan balance, market conditions, fees, and costs at the time of liquidation.',
      },
      {
        question: 'At what price will my crypto be sold?',
        answer: 'Crypto is sold at the market execution price available at the time of liquidation. Execution prices may differ from quoted market prices.',
      },
      {
        question: 'Can a liquidation be reversed?',
        answer: 'No. Once a liquidation occurs, it cannot be reversed.',
      },
      {
        question: 'Does liquidation close my loan?',
        answer: 'Not always. Partial liquidation may reduce your loan balance while keeping the loan active. Full liquidation may result in loan payoff depending on proceeds.',
      },
      {
        question: 'What happens if there is surplus after liquidation?',
        answer: 'If liquidation proceeds exceed your outstanding loan balance, applicable fees, and costs, any remaining surplus will be returned to you.',
      },
    ],
  },
  {
    id: 'custody-security',
    title: 'Custody & Security',
    questions: [
      {
        question: 'What is crypto collateral?',
        answer: 'Crypto collateral is the cryptocurrency you pledged to secure your loan. You retain ownership unless it is liquidated in accordance with your loan agreement.',
      },
      {
        question: 'Who holds my crypto collateral?',
        answer: 'Your collateral is being held by a custodian, a regulated digital asset entity that securely holds your crypto.',
      },
      {
        question: 'Who has access to my crypto?',
        answer: 'Your crypto collateral is held in custody and may only be accessed as permitted under your loan agreement.',
      },
      {
        question: 'Are there tax implications?',
        answer: 'Liquidation or repayment of a crypto-backed loan may have tax implications depending on your circumstances. LendingUSA does not provide tax advice. Please consult a qualified tax advisor.',
      },
    ],
  },
];

export const getFaqCategories = (loanType) => (
  loanType === FAQ_LOAN_TYPES.CRYPTO ? CRYPTO_FAQ_CATEGORIES : REGULAR_FAQ_CATEGORIES
);

export const filterFaqCategories = (categories, searchQuery) => {
  const query = String(searchQuery || '').trim().toLowerCase();

  if (!query) {
    return categories;
  }

  return categories
    .map((category) => ({
      ...category,
      questions: category.questions.filter(
        (item) => item.question.toLowerCase().includes(query)
          || item.answer.toLowerCase().includes(query)
      ),
    }))
    .filter((category) => category.questions.length > 0);
};

export const getQuestionKey = (categoryId, questionIndex) => `${categoryId}-${questionIndex}`;
